import {
  blue,
  cyan,
  deepPurple,
  green,
  grey,
  indigo,
  orange,
  purple,
  red,
  yellow,
} from "@mui/material/colors";

export const air_tempLineChart = Object.freeze({
  textfont: { color: "red" },
  fill: "tonexty",
  fillcolor: red[100],
  line: { color: red[800] },
  mode: "lines",
  name: "Temperatura",
  type: "scatter",
});

export const air_humLineChart = Object.freeze({
  fill: "tonexty",
  fillcolor: indigo[100],
  line: { color: indigo[800] },
  mode: "lines",
  name: "humidity",
  type: "scatter",
});

export const co2LineChart = Object.freeze({
  fill: "tonexty",
  fillcolor: grey[200],
  line: { color: grey[800] },
  mode: "lines",
  name: "CO2",
  type: "scatter",
});

export const luxLineChart = Object.freeze({
  fill: "tonexty",
  fillcolor: yellow[300],
  line: { color: yellow[700] },
  mode: "lines",
  name: "Illuminamento",
  type: "scatter",
});

export const bar_pressLineChart = Object.freeze({
  fill: "tonexty",
  fillcolor: green[100],
  line: { color: green[800] },
  mode: "lines",
  name: "Pressione atmosferica",
  type: "scatter",
});
export const pcountLineChart = Object.freeze({
  fill: "tonexty",
  fillcolor: orange[100],
  line: { color: orange[500] },
  mode: "lines",
  name: "Affollamento",
  type: "scatter",
});

export const pmLineChart = Object.freeze([
  {
    line: { color: deepPurple[500] },
    mode: "lines",
    name: "PM 2.5",
    type: "scatter",
  },
  {
    line: { color: purple[500] },
    mode: "lines",
    name: "PM 10",
    type: "scatter",
  },
]);

export const windLineChart = Object.freeze([
  {
    textfont: { color: "black" },
    mode: "lines",
    type: "scatter",
    name: "Velocità",
    line: { dash: "dot", color: cyan[800], width: 0.8 },
  },
  {
    mode: "lines+text",
    type: "scatter",
    textfont: {
      size: 17,
      color: cyan[800],
    },
    line: { width: 0 },
    name: " ",
  },
]);

export const rainLineChart = Object.freeze([
  {
    mode: "lines",
    name: "Intensity",
    type: "scatter",
    line: {
      color: blue[500],
    },
  },
  {

    mode: "lines",
    name: "Peak",
    type: "scatter",
    line: {
      color: '#1d5c8f',
    },
  },
]);

export const getMinMaxLineChart = (min, max) => {
  return [min - Math.abs(min * 0.05), max + Math.abs(max * 0.05)];
};
